//
// Software Name: Orange Design System Charts
// SPDX-FileCopyrightText: Copyright (c) 2023 - 2026 Orange SA
// SPDX-License-Identifier: MIT
//
// This software is distributed under the MIT license.
//
export const DEFAULT_COLORS_FUNCTIONAL = {
    color: [
        'var(--ods-functional-1, #F16E00)',
        'var(--ods-functional-2, #EEEEEE)',
        'var(--ods-functional-3, #228722)',
        'var(--ods-functional-4, #FFCC00)',
        'var(--ods-functional-5, #CD3C14)',
        'var(--ods-functional-6, #4170D8)',
    ],
};
